/**
 * Normaliza traducciones de calendario que llegan como array u objeto indexado.
 *
 * @param {*} value
 * @returns {string[]}
 */
export function toStringArray(value) {
    if (Array.isArray(value)) {
        return value.map((item) => String(item))
    }

    if (value && typeof value === 'object') {
        return Object.keys(value)
            .sort((left, right) => Number(left) - Number(right))
            .map((key) => String(value[key]))
    }

    return []
}
